<apx-chart
  [series]="chartOptions?.series"
  [chart]="chartOptions?.chart"
  [plotOptions]="chartOptions?.plotOptions"
  [title]="chartOptions?.title"
  [labels]="chartOptions?.labels"
  [legend]="chartOptions?.legend"
  [colors]="chartOptions?.colors"
></apx-chart>
